import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { EAdvancedFilterOptions } from '../../../../models/advanced-filter-options.enum';
import {
  TAdvancedFilterSingle,
  TAdvancedFilterText,
  TFilterTextOptions,
  TFilterTextOptionsMandatory,
} from '../../../../models/advanced-filter.model';

import { EPointSearchOperator } from 'src/app/project/modules/points/point-search/point-search.consts';
import {
  textOperationWithMandatoryOptions,
  titleOperationOptions,
} from '../../../../utils/advanced-filter-operator.utils';

@Component({
  selector: 'pp-advanced-filter-text',
  templateUrl: './advanced-filter-text.component.html',
  styleUrls: ['./advanced-filter-text.component.scss'],
  standalone: false,
})
export class AdvancedFilterTextComponent {
  @Input() ppFilter: TAdvancedFilterSingle;
  @Input() isTitleType?: boolean;
  @Output() ppFilterChange = new EventEmitter<TAdvancedFilterSingle>();

  value: string;
  option: TFilterTextOptions | TFilterTextOptionsMandatory;
  filter: TAdvancedFilterText;

  advancedFilterTextOptions: TSelectOption[];
  EAdvancedFilterOptions = EAdvancedFilterOptions;

  private static readonly EMPTY_FILTER_VALUE = [null, ''];

  ngOnInit() {
    this.advancedFilterTextOptions = this.isTitleType
      ? titleOperationOptions
      : textOperationWithMandatoryOptions;
  }

  ngOnChanges(): void {
    this.filter = this.ppFilter as TAdvancedFilterText;

    if (
      this.filter.option === EAdvancedFilterOptions.IS_EMPTY ||
      this.filter.option === EAdvancedFilterOptions.IS_NOT_EMPTY
    ) {
      this.ppFilter.value = AdvancedFilterTextComponent.EMPTY_FILTER_VALUE;
    } else if (this.isEmptyFilterValue(this.filter.value)) {
      this.ppFilter.value = undefined;
    }

    this.value = this.filter.value;
    this.option = this.filter.option;
  }

  private isEmptyFilterValue(value: unknown): boolean {
    return Array.isArray(value) && value.length === 2 && value[0] === null && value[1] === '';
  }

  changeFieldCondition(newCondition: TSelectOption): void {
    this.ppFilter.option = newCondition.value as TFilterTextOptions;

    this.ppFilter.operator = newCondition.operator;

    if (
      (newCondition.operator === EPointSearchOperator.IN ||
        newCondition.operator === EPointSearchOperator.NOT_IN) &&
      newCondition?.data
    ) {
      this.ppFilter.value = newCondition.data;
    }

    this.option = newCondition.value as TFilterTextOptions;
    this.applyChanges();
  }

  applyChanges(): void {
    this.ppFilterChange.emit(this.ppFilter);
  }

  changeFieldValue(value: string): void {
    this.ppFilter.value = value;
    this.applyChanges();
  }
}
